import './lesson-footer.less';
import { ArrowRight, Play } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

/**
 * 从 chapterId 生成确定性的 session ID，用作 URL 路径段。
 * 格式：academy-{chapterId}
 */
export function toAcademySessionId(chapterId: number | string): string {
	return `academy-${chapterId}`;
}

/** 判断 URL 路径段是否为 academy session ID */
export function isAcademySessionId(slug: string): boolean {
	return slug.startsWith('academy-');
}

/** 课程入口跳转 workplace 时携带的上下文（通过 location.state 传递） */
export interface AcademyWorkplaceState {
	courseTitle?: string;
	chapterTitle?: string;
	description?: string;
}

interface LessonFooterProps {
	isCompleted?: boolean;
	nextChapter?: { id: number; title: string } | null;
	onNext: (chapterId: number) => void;
	courseContext?: {
		chapterId: number;
		courseTitle?: string;
		chapterTitle?: string;
		description?: string;
	};
}

export function LessonFooter({ isCompleted, nextChapter, onNext, courseContext }: LessonFooterProps) {
	const navigate = useNavigate();

	return (
		<div className="lesson-footer">
			<div className="lesson-footer__inner">
				{/* ── Left: completion status ── */}
				<div />

				{/* ── Right: practice + next chapter ── */}
				<div className="lesson-footer__right">
					{courseContext?.description && (
						<button
							className="lesson-footer__practice-btn"
							onClick={() => {
								const sessionId = toAcademySessionId(courseContext.chapterId);
								navigate(`/workplace/${sessionId}`, {
									state: {
										courseTitle: courseContext.courseTitle,
										chapterTitle: courseContext.chapterTitle,
										description: courseContext.description,
									},
								});
							}}
							type="button"
						>
							<Play className="h-4 w-4" />
							在AI Office中演练
						</button>
					)}

					{nextChapter && (
						<button className="lesson-footer__next-btn" onClick={() => onNext(nextChapter.id)} type="button">
							<div className="lesson-footer__next-content">
								<span className="lesson-footer__next-label">下一课</span>
								<span className="lesson-footer__next-title">{nextChapter.title}</span>
							</div>
							<ArrowRight className="lesson-footer__next-arrow" />
						</button>
					)}
				</div>
			</div>
		</div>
	);
}
